import React, { PointerEvent as ReactPonterEvent, useRef } from 'react';
import { styled } from '@mui/material/styles';

const Aside = styled('aside')(`
  max-width: 50%;
  border-right: 1px solid #DFE1E6;
  display: flex;
  background-color: #fff;
`);

const Container = styled('div')({
  height: '100%',
  overflow: 'hidden',
  padding: 0,
  margin: 0,
  backgroundColor: '#fff',
  fontSize: '0.8rem',
  minWidth: '110px'
});

const DraggerContainer = styled('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center',
  justifyContent: 'center',
  width: '1px',
  overflow: 'visible',
  height: '100%',
  padding: '0px',
  boxSizing: 'border-box'/*,
  '&:hover': {
    boxShadow: '0px 0px 1px 1px rgb(0 189 247 / 50%)'
  }*/
});

const Dragger = styled('div')({
  position: 'absolute',
  alignItems: 'center',
  justifyContent: 'center',
  width: '9px',
  height: '100%',
  cursor: 'ew-resize',
  padding: '0px',
  boxSizing: 'border-box',
  zIndex: '100'/*,
  '&:hover': {
    boxShadow: '0px 0px 1px 1px rgb(0 189 247 / 50%)'
  }*/
});

type SidebarProps = {
  children: any,
  sx?: any,
  width?: number,
  onResize?: (width: number) => void | Promise<void>
};

export default ({ children, sx, width = 340, onResize }: SidebarProps) => {

  const sidebarRef = useRef<HTMLDivElement>(null);

  let resizing = false;

  const drag = (event: PointerEvent) => {
    if (resizing && sidebarRef && sidebarRef.current) {
      sidebarRef.current.style.width = `${event.clientX - sidebarRef.current.getBoundingClientRect().left}px`;
      window.dispatchEvent(new Event('resize'));
    }
  };

  const stop = () => {
    resizing = false;
    window.removeEventListener("pointermove", drag);
    window.removeEventListener("pointerup", stop);
    if (sidebarRef && sidebarRef.current && onResize) {
      onResize(sidebarRef.current.offsetWidth);
    }
  };

  const start = (event: ReactPonterEvent) => {
    if (event.pointerType !== 'mouse' || event.button == 0) {
      window.addEventListener("pointermove", drag);
      window.addEventListener("pointerup", stop);
      resizing = true;
      event.stopPropagation();
      event.preventDefault();
    }
  };

  return (
    <Aside sx={sx}>
      <Container ref={sidebarRef} sx={{ width }}>{ children }</Container>
      <DraggerContainer>
        <Dragger onPointerDown={start} />
      </DraggerContainer>
    </Aside>
  );
};